module.exports = "<p class=\"control-label\">{{t('actionVpn.secret')|e}}</p>\n<p>{{t('configEdit.valHidden')|e}}</p>\n";
